<template>
  <RfSelect
    ref="timePickerSelect"
    v-model="time"
    variant="outlined"
    :title="label"
    :disabled="disabled"
    name="time"
    :items="items"
    @update:modelValue="changeHandler"
  />
</template>

<script setup>
import { ref, onMounted, useTemplateRef, computed } from "vue";
import StringUtils from "@/utils/StringUtils";
import RfSelect from "./inputs/RfSelect.vue";

const props = defineProps(["label", "error", "density", "updateTime", "initTime", "disabled"]);
const emit = defineEmits(["updateTime"]);

const time = ref(0);
const timePickerSelect = useTemplateRef("timePickerSelect");

const items = Array.from(Array(48).keys())
  .map(index => ({
    text: StringUtils.hhmmBy30MinIntervalIndex(index),
    value: index,
  }))
  .concat([{ text: "23:59", value: 48 }]);

const changeHandler = () => emit("updateTime", time.value);

onMounted(() => (time.value = props.initTime));

defineExpose({ time, opened: computed(() => timePickerSelect.value?.opened) });
</script>
